import i18n from '@/i18n'

export const successMsg = {
  'delete-so/list': (total) => i18n.t('salesOrder.toast.deleteSO.list.success', { total }),
  'delete-so/detail': (total) => i18n.t('salesOrder.toast.deleteSO.detail.success', { total }),
  'transition-draft': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.draft', { soNumber }),
  'transition-confirmed': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.confirmed', { soNumber }),
  'transition-assigned': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.assigned', { soNumber }),
  'transition-completed': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.completed', { soNumber }),
  'transition-canceled': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.canceled', { soNumber }),
}

export const errorMsg = {
  'delete-so/list': (total) => i18n.t('salesOrder.toast.deleteSO.list.failed', { total }),
  'delete-so/detail': (total) => i18n.t('salesOrder.toast.deleteSO.detail.failed', { total }),
  'delete-so-assigned/detail': (soNumber) => i18n.t('salesOrder.toast.deleteSO.assigned', { soNumber }),
  'transition/default': () => i18n.t('salesOrder.toast.transition.failed'),
  'transition-draft': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.draft', { soNumber }),
  'transition-confirmed': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.confirmed', { soNumber }),
  'transition-assigned': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.assigned', { soNumber }),
  'transition-completed': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.completed', { soNumber }),
  'transition-canceled': (soNumber) => i18n.t('salesOrder.toast.transition.success.status.canceled', { soNumber }),
}